import { useMemo } from 'react';
import { useGlobalComponent } from '@rhino-project/core/hooks';
import {
  useTableInheritedProps,
  TableInheritedProps
} from '@rhino-project/core/hooks';

export const CellImageBase = ({
  empty = '-',
  ...props
}: TableInheritedProps & { empty?: string }) => {
  const { getValue, inheritedProps } = useTableInheritedProps(props);
  const src = useMemo(() => getValue!(), [getValue]);

  if (!src) return <div {...inheritedProps}>{empty}</div>;

  return (
    <img
      alt={src}
      src={src}
      // Ensure image doesn't overflow table cell
      style={{ height: '50px', maxWidth: '100%' }}
      {...inheritedProps}
    />
  );
};

export const CellImage = (props: TableInheritedProps) =>
  useGlobalComponent('CellImage', CellImageBase, props);
